import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { Drawer as Drawer$1 } from 'vaul';
import { cn } from '../../lib/utils.js';

const Drawer = (_a) => {
    var { shouldScaleBackground = true } = _a, props = __rest(_a, ["shouldScaleBackground"]);
    return (jsx(Drawer$1.Root, Object.assign({ shouldScaleBackground: shouldScaleBackground }, props)));
};
Drawer.displayName = 'Drawer';
Drawer$1.Trigger;
const DrawerPortal = Drawer$1.Portal;
Drawer$1.Close;
const DrawerOverlay = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx(Drawer$1.Overlay, Object.assign({ ref: ref, className: cn('tw:fixed tw:inset-0 tw:z-50 tw:bg-primary/80', className) }, props)));
});
DrawerOverlay.displayName = Drawer$1.Overlay.displayName;
const DrawerContent = React.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (jsxs(DrawerPortal, { children: [jsx(DrawerOverlay, {}), jsxs(Drawer$1.Content, Object.assign({ ref: ref, className: cn('tw:fixed tw:inset-x-0 tw:bottom-0 tw:z-50 tw:mt-24 tw:flex tw:h-auto tw:flex-col tw:rounded-t-[10px] tw:border tw:bg-background', className) }, props, { children: [jsx("div", { className: "tw:mx-auto tw:mt-4 tw:h-2 tw:w-[100px] tw:rounded-full tw:bg-muted" }), children] }))] }));
});
DrawerContent.displayName = 'DrawerContent';
const DrawerHeader = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx("div", Object.assign({ className: cn('tw:grid tw:gap-1.5 tw:p-4 tw:text-center tw:sm:text-left', className) }, props)));
};
DrawerHeader.displayName = 'DrawerHeader';
const DrawerTitle = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx(Drawer$1.Title, Object.assign({ ref: ref, className: cn('tw:text-lg tw:font-semibold tw:leading-none tw:tracking-tight', className) }, props)));
});
DrawerTitle.displayName = Drawer$1.Title.displayName;
const DrawerDescription = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx(Drawer$1.Description, Object.assign({ ref: ref, className: cn('tw:text-sm tw:text-muted-foreground', className) }, props)));
});
DrawerDescription.displayName = Drawer$1.Description.displayName;

export { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerOverlay, DrawerPortal, DrawerTitle };
//# sourceMappingURL=drawer.js.map
